import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AdminPanel from './AdminPanel';
import './Footer.css';
import { useConfig } from '../ConfigContext';
import { getApiBaseUrl } from '../config';

function Footer() {
  const config = useConfig();
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [adminUsername, setAdminUsername] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [adminError, setAdminError] = useState('');
  const [expandedSections, setExpandedSections] = useState({});
  const [adminToken, setAdminToken] = useState(null);

  const toggleSection = (sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  const handleAdminLogin = async (username, password) => {
    try {
      const apiUrl = getApiBaseUrl();
      const response = await fetch(`${apiUrl}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        setAdminToken(data.token);
        setShowAdminLogin(false);
        setShowAdminPanel(true);
        setAdminError('');
        return { success: true, token: data.token };
      } else {
        const errorMsg = data.error || 'Login failed';
        setAdminError(errorMsg);
        setAdminUsername('');
        setAdminPassword('');
        return { success: false, error: errorMsg };
      }
    } catch (err) {
      console.error('Admin login error:', err);
      const errorMsg = 'Login error: ' + err.message;
      setAdminError(errorMsg);
      setAdminUsername('');
      setAdminPassword('');
      return { success: false, error: errorMsg };
    }
  };

  const handleAdminSubmit = async (e) => {
    e.preventDefault();
    await handleAdminLogin(adminUsername, adminPassword);
  };

  const handleCloseAdmin = () => {
    setShowAdminPanel(false);
  };
  return (
    <footer className="footer">
      {config.footer.enabled && (
        <>
          <div className="footer-content">
            {config.footer.logo && (
              <div className="footer-section">
                <a href={config.footer.logoLink} target="_blank" rel="noopener noreferrer" className="footer-logo-link">
                  <div className="footer-logo">
                    <img src="/images/general/TAM-logo-transparent.png" alt="TAM" className="footer-logo-img" />
                    {config.footer.address && (
                      <p className="footer-address">
                        {config.footer.address.split('\n').map((line, idx) => (
                          <React.Fragment key={idx}>
                            {line}
                            {idx < config.footer.address.split('\n').length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                    )}
                  </div>
                </a>
                {config.footer.socialLinks && (
                  <div className="footer-social-links">
                    {config.footer.socialLinks.linkedin && (
                      <a 
                        href={config.footer.socialLinks.linkedin} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="social-button"
                        aria-label="LinkedIn"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.475-2.236-1.986-2.236-1.081 0-1.722.722-2.004 1.418-.103.249-.129.597-.129.946v5.441h-3.554s.05-8.807 0-9.722h3.554v1.377c.43-.662 1.19-1.602 2.889-1.602 2.108 0 3.684 1.375 3.684 4.331v5.616zM5.337 8.855c-1.144 0-1.915-.762-1.915-1.715 0-.955.77-1.715 1.916-1.715.95 0 1.914.76 1.914 1.715 0 .953-.963 1.715-1.915 1.715zm1.946 11.597H3.392V9.73h3.891v10.722zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
                        </svg>
                      </a>
                    )}
                    {config.footer.socialLinks.github && (
                      <a 
                        href={config.footer.socialLinks.github} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="social-button"
                        aria-label="GitHub"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                        </svg>
                      </a>
                    )}
                  </div>
                )}
              </div>
            )}

            {config.footer.sections.product.enabled && (
              <div className="footer-section">
                <h4 
                  style={{ fontSize: config.fontSizes.footer.sectionTitle }}
                  className={`footer-section-title ${expandedSections.product ? 'expanded' : ''}`}
                  onClick={() => toggleSection('product')}
                >
                  Product
                </h4>
                <ul className={`footer-section-list ${expandedSections.product ? 'expanded' : ''}`}>
                  {config.footer.sections.product.items.pryme && <li><Link to="/pryme" style={{ fontSize: config.fontSizes.footer.link }}>{config.navbar.productNames.primary}</Link></li>}
                  {config.footer.sections.product.items.apex && <li><Link to="/apex" style={{ fontSize: config.fontSizes.footer.link }}>{config.navbar.productNames.secondary}</Link></li>}
                </ul>
              </div>
            )}

            {config.footer.sections.company.enabled && (
              <div className="footer-section">
                <h4 
                  style={{ fontSize: config.fontSizes.footer.sectionTitle }}
                  className={`footer-section-title ${expandedSections.company ? 'expanded' : ''}`}
                  onClick={() => toggleSection('company')}
                >
                  Company
                </h4>
                <ul className={`footer-section-list ${expandedSections.company ? 'expanded' : ''}`}>
                  {config.footer.sections.company.items.aboutUs && <li><a href={config.navbar.aboutUs.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: config.fontSizes.footer.link }}>About Us</a></li>}
                  {config.footer.sections.company.items.contact && <li><a href={config.navbar.contactUs.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: config.fontSizes.footer.link }}>Contact</a></li>}
                </ul>
              </div>
            )}

            {config.footer.sections.legal.enabled && (
              <div className="footer-section">
                <h4 
                  style={{ fontSize: config.fontSizes.footer.sectionTitle }}
                  className={`footer-section-title ${expandedSections.legal ? 'expanded' : ''}`}
                  onClick={() => toggleSection('legal')}
                >
                  Legal
                </h4>
                <ul className={`footer-section-list ${expandedSections.legal ? 'expanded' : ''}`}>
                  {config.footer.sections.legal.items.privacy && <li><Link to="/privacy" style={{ fontSize: config.fontSizes.footer.link }}>Privacy Policy</Link></li>}
                  {config.footer.sections.legal.items.terms && <li><Link to="/terms" style={{ fontSize: config.fontSizes.footer.link }}>Terms of Use</Link></li>}
                  {config.footer.sections.legal.items.accessibility && <li><Link to="/accessibility" style={{ fontSize: config.fontSizes.footer.link }}>Accessibility</Link></li>}
                </ul>
              </div>
            )}
          </div>

          {config.footer.copyright && (
            <div className="footer-bottom">
              <p style={{ fontSize: config.fontSizes.footer.copyright }}>&copy; 2026 Think-a-Move LTD. All rights reserved.</p>
              <button 
                className="footer-admin-link"
                onClick={() => setShowAdminLogin(true)}
                type="button"
              >
                Admin
              </button>
            </div>
          )}
        </>
      )}

      {showAdminLogin && (
        <div className="admin-login-overlay">
          <div className="admin-login-modal">
            <h2>Admin Login</h2>
            <form onSubmit={handleAdminSubmit}>
              <input
                type="text"
                value={adminUsername}
                onChange={(e) => setAdminUsername(e.target.value)}
                placeholder="Enter admin username"
                autoFocus
              />
              <input
                type="password"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                placeholder="Enter admin password"
              />
              {adminError && <div className="login-error">{adminError}</div>}
              <div className="login-buttons">
                <button type="button" onClick={() => setShowAdminLogin(false)}>Cancel</button>
                <button type="submit">Login</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showAdminPanel && <AdminPanel token={adminToken} onClose={handleCloseAdmin} />}
    </footer>
  );
}

export default Footer;
